module.exports = __webpack_public_path__ + "static/media/015-Joe Dogs.ec755927.jpeg";